import { parseUnits } from '@ethersproject/units'
import store from 'state'
import { GAS_PRICE } from 'state/user/hooks/helpers'


export const fetchGasPrice = async (): Promise<string> => {

  // TODO fetch gas price  
  const gasPrice = parseUnits('500', 'gwei').toString();

  return null;
}
/**
 * Function to return gasPrice outwith a react component
 */
const getGasPrice = async (): Promise<string> => {
  const state = store.getState()
  const userGas = state.user.userGas || GAS_PRICE.default;
  const gasPrice = await fetchGasPrice();

  // TODO calculate gas price with userGas 
  switch (userGas) {
    case GAS_PRICE.default:
      return gasPrice;

    case GAS_PRICE.fast:
      return gasPrice;

    case GAS_PRICE.instant:
      return gasPrice;

    default:
      return gasPrice;

  }

}

export default getGasPrice
